// frontend/src/config.js
import axios from "axios";

axios.defaults.withCredentials = true;

// Produccion: backend-imporisel en el dominio del mismo sitio para conservar la sesion.
let API_URL = "https://api.imporisel.com/api";

// Dev local:
if (typeof window !== "undefined") {
  const h = window.location.hostname;
  if (h === "localhost" || h === "127.0.0.1") {
    API_URL = "http://localhost:5000/api";
  }
}

export default API_URL;
